

const moduleColors = {
    partiallyAttempted: "#F1D560",
    currentlySelected: "#007BFF",
    wrongAnswer: "#C71B16",
    noAction: "#757589",
    rightAnswer: "#57BD72",
}

const moduleBoxHWBr = {
    borderRadius: 4,
    width: 20,
    height: 20,
}

const moduleDesc = {
    color: "#757589",
    fontSize: 12
}

const questionsModule = {
    width: 35,
    height: 34,
    borderRadius: "50%",
    border: "1px solid #DFDFDF",
    fontSize: 14,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer"
}

const questions = {
    rightAnswer: { backgroundColor: moduleColors.rightAnswer, color: "#fff", ...questionsModule },
    partiallyAttempted: { backgroundColor: moduleColors.partiallyAttempted, color: "#fff", ...questionsModule },
    currentlySelected: { ...questionsModule, border: "3px solid black" },
    wrongAnswer: { backgroundColor: moduleColors.wrongAnswer, color: "#fff", ...questionsModule },
    noAction: { color: moduleColors.noAction, backgroundColor: "#fff", ...questionsModule }
}

const getQuestionIndicatorStyle = (activity, i, currentQuestionIndex) => {
    let styleToReturn = {};

    // Check if response text is not empty
    if (activity?.questionresponse_set?.response_text || activity?.questionresponse_set?.response_options_ids?.length > 0) {
        styleToReturn = { backgroundColor: "lightgreen", ...questionsModule };
    } else {
        styleToReturn = { backgroundColor: "white", ...questionsModule };
    }

    // Add logic for current question index
    if (currentQuestionIndex === i) {
        styleToReturn = { ...styleToReturn, ...questions.currentlySelected };
    }

    return styleToReturn;
};

export {
    moduleBoxHWBr,
    moduleColors,
    getQuestionIndicatorStyle,
    questions,
    moduleDesc,
    questionsModule
}